import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../store';

import { createUser, deleteUser, getAllUser, signIn, SignInParams, SignUpParams, updateUser } from '../api/auth';

export interface AuthState {
    busy: boolean; //0: idle, 1:busy, 2:error
    isAuth: boolean;
    user: {
        _id:string,
        username: string,
        email: string,
        userType: number
    } | undefined;
    results: any[];
    selectedUser: any;
     loginError: {
        email?: string;
        password?: string;
        general?: string;
    } | null;
}

const initialState: AuthState = {
    busy: false,
    isAuth: false,
    user: undefined,
    results: [],
    selectedUser: undefined,
    loginError: null
}

export const signinAsync = createAsyncThunk(
  'auth/signin',
  async (formData: SignInParams, { rejectWithValue }) => {
    try {
      const response = await signIn(formData);
      return response.response;
    } catch (err: any) {
      return rejectWithValue(err?.error?.response?.data || { errors: [{ general: 'Login failed' }] });
    }
  }
);

export const getAllUsersAsync = createAsyncThunk(
    'auth/getAllUsers',
    async () => {
      const response = await getAllUser();
      // The value we return becomes the `fulfilled` action payload
      return response.response;
    }
);

export const createUserAsync = createAsyncThunk(
    'auth/createUser',
    async (formData: SignUpParams) => {
      const response = await createUser(formData);
      // The value we return becomes the `fulfilled` action payload
      return response.response;
    }
);

export const updateUserAsync = createAsyncThunk(
    'auth/updateUser',
    async (formData: SignUpParams) => {
      const response = await updateUser(formData);
      // The value we return becomes the `fulfilled` action payload
      return response.response;
    }
);


// export const signinAsync = createAsyncThunk(
//     'auth/signin',
//     async (formData: SignInParams) => {
//       const response = await signIn(formData);
//       // The value we return becomes the `fulfilled` action payload
//       return response.response;
//     }
// );
const parseLoginErrors = (payload: any) => {
    const parsed: {
        email?: string;
        password?: string;
        general?: string;
    } = {};
    console.log(payload)
    if (payload?.errors && Array.isArray(payload.errors)) {
        payload.errors.forEach((item: any) => {
            if (item.email === 'required') {
                parsed.email = 'Email is required';
            } else if (item.email === 'invalid email') {
                parsed.email = 'Invalid email address';
            } else if (item.user === 'not found') {
                parsed.email = 'Email not found';
            } else if (item.password === 'required') {
                parsed.password = 'Please enter password';
            } else if (item.password === 'incorrect') {
                parsed.password = 'Incorrect password';
            } else if (item.general) {
                parsed.general = item.general;
            }
        });
    } else {
        parsed.general = 'Login failed';
    }

    return parsed;
};
export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setUserData: (state, action: PayloadAction<any>) => {
            state.isAuth = true;
            state.user = action.payload;
            console.log("LOCAL1", action.payload)
        },
        setSelectedUser: (state, action: PayloadAction<any>) => {
            state.selectedUser = action.payload;
        },
        removeUser: (state, action: PayloadAction<any>) => {
            state.busy = false;
            state.isAuth = false;
            localStorage.removeItem('username');
            localStorage.removeItem('email');
            localStorage.removeItem('userType');
        },
        clearLoginError: (state) => {
    state.loginError = null;
},
    },
    extraReducers: (builder) => {
        builder
            .addCase(signinAsync.pending, (state) => {
                state.busy = true;
                state.loginError = null;
            })
            .addCase(signinAsync.fulfilled, (state, action) => {

                const { data } = action.payload;
                console.log("auth data",data)
                state.busy = false;
                state.isAuth = true;
                state.user = data;
                state.loginError = null;
                localStorage.setItem('username', data.username);
                localStorage.setItem('email', data.email);
                localStorage.setItem('userType', data.userType);
                localStorage.setItem('userID', data._id);
            })
            .addCase(signinAsync.rejected, (state,action) => {
                state.busy = false
                state.isAuth = false;
                state.loginError = parseLoginErrors(action.payload);
            })

            .addCase(getAllUsersAsync.pending, (state) => {
                state.busy = true
            })
            .addCase(getAllUsersAsync.fulfilled, (state, action) => {
                state.results = action.payload.data;
                state.busy = false;
            })
            .addCase(getAllUsersAsync.rejected, (state) => {
                state.busy = false;
            })

            .addCase(createUserAsync.pending, (state) => {
                state.busy = true
            })
            .addCase(createUserAsync.fulfilled, (state, action) => {
                state.busy = false;
            })
            .addCase(createUserAsync.rejected, (state) => {
                state.busy = false;
            })

            .addCase(updateUserAsync.pending, (state) => {
                state.busy = true
            })
            .addCase(updateUserAsync.fulfilled, (state, action) => {
                state.busy = false;
            })
            .addCase(updateUserAsync.rejected, (state) => {
                state.busy = false;
            })
    }
})

export const { setUserData, setSelectedUser , removeUser,clearLoginError} = authSlice.actions;

export const getUser = (state: RootState) => state.auth;
export const getSelectedUser = (state: RootState) => state.auth.selectedUser;


export default authSlice.reducer;